import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';

import { RootStateBase } from '../../../store/baseStore';

import * as S from './styles'

import { Button } from '../../../components/Button';
import { Icon } from '@iconify/react';
import { RemoveSuccess } from '../../../store/base/action/baseAction';
import { StateType } from 'domain/types/base/base';
import { Modal, ModalContent } from '../../../components/Modal';

const connector = connectUtil(
    (state: RootStateBase) => ({
        success: state.BaseReducer.Success,
    }),
    { RemoveSuccess }
);

export interface LoadingProps extends PropsFromRedux<typeof connector> {
}

function MasterSuccess(props: LoadingProps) {
    const success = props.success.filter((e) => e.CallBack);
    const successLastIndex = success.length - 1;
    const callBackText = typeof success[successLastIndex]?.CallBack !== 'function' ? success[successLastIndex]?.CallBack?.CallBackText : "Ok!";


    function handleClick() {
        success.forEach((s) => {
            if (typeof s?.CallBack === 'function') {
                s.CallBack();
            } else {
                s?.CallBack.CallBack();
            }
        })
        props.RemoveSuccess()
    }

    return (
        <Modal open={props.success.find((e) => e.Type == StateType.Master) ? true : false}>
            <ModalContent 
                overlayStyle={{
                    opacity: 0.9, 
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    backdropFilter: 'blur(8px)'
                }}
                contentStyle={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '20px',
                    backgroundColor: 'transparent',
                    boxShadow: 'none'
                }}
            >
                <S.Container $variant="success">
                    <S.IconContainer $variant="success">
                        <Icon 
                            icon="mdi:check-circle" 
                            style={{ 
                                fontSize: '72px', 
                                color: '#22c55e',
                                position: 'relative',
                                zIndex: 1,
                                filter: 'drop-shadow(0 4px 12px rgba(34, 197, 94, 0.3))'
                            }} 
                        />
                    </S.IconContainer>
                    <S.Title $variant="success">
                        Sucesso!
                    </S.Title>
                    <S.MessageContainer>
                        {props.success.map((m, index) => (
                            <S.Message key={index}>{m.Message}</S.Message>
                        ))}
                    </S.MessageContainer>
                    <S.ButtonContainer>
                        <Button 
                            onClick={handleClick} 
                            iconPosition='left' 
                            size='lg'
                            full={true}
                            style={{ 
                                borderRadius: '12px', 
                                height: '52px', 
                                fontSize: '16px', 
                                fontWeight: '600',
                                backgroundColor: '#22c55e',
                                borderColor: '#22c55e',
                                transition: 'all 200ms ease-in-out',
                                boxShadow: '0 8px 24px rgba(34, 197, 94, 0.25)',
                                gap: '8px'
                            }}
                        >
                            <Icon icon="mdi:check" height="20px" color={"white"} />
                            {callBackText}
                        </Button>
                    </S.ButtonContainer>
                </S.Container>
            </ModalContent>
        </Modal>
    )
}

export default connector(MasterSuccess);
